<div class="flex flex-col">
  <span class="whitespace-nowrap">{{address?.street}} {{address?.number}} {{address?.addition}}</span>
  <span class="">{{address?.postalcode}} {{address?.city}}</span>
  <span class="">{{'countrycode.' + address?.countrycode |translate}}</span>
</div>
